const staff = {
    'adrienne-mcconnell': {
        fullName:         'Dr. Adrienne McConnell',
        firstName:        'Adrienne',
        slug:             'adrienne-mcconnell',
        mainDiscipline:   'Chiropractor',
        extraDisciplines: '',
        letters:          'BA Kin(Hons), DC',
        miniBio:          'Dr. Adrienne McConnell is a Chiropractor, Acupuncture Provider, Certified Personal Trainer and Pilates Instructor. She earned her Doctor of Chiropractic degree from the Canadian Memorial Chiropractic College, and received a Specialized Honours Bachelor of Arts Degree in Kinesiology from York University.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/1',
        onHomePage:       true,
        type:             'practitioner',
    },
    'dana-bondy': {
        fullName:         'Dana Bondy',
        firstName:        'Dana',
        slug:             'dana-bondy',
        mainDiscipline:   'Pilates Instructor',
        extraDisciplines: '',
        letters:          '',
        miniBio:          'Dana became passionate about Pilates as it impacted her life as a professional dancer and became necessary for injury prevention and rehabilitation.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/32',
        onHomePage:       true,
        type:             'instructor',
    },
    'emily-younes': {
        fullName:         'Dr. Emily Younes',
        firstName:        'Emily',
        slug:             'emily-younes',
        mainDiscipline:   'Chiropractor',
        extraDisciplines: 'Acupuncture Provider, FRC® and FR® Provider, AMA®, DNS-A®, ISS®',
        letters:          'BSc. Kin(Hons), DC',
        miniBio:          'Dr. Emily is a Chiropractor, Acupuncture Provider and Performance Therapist with a passion for fitness and medicine.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/30',
        onHomePage:       true,
        type:             'practitioner',
    },
    'kate-fewer': {
        fullName:         'Kate Fewer',
        firstName:        'Kate',
        slug:             'kate-fewer',
        mainDiscipline:   'Physiotherapist',
        extraDisciplines: '',
        letters:          'BScPT',
        miniBio:          'Kate Fewer earned her Bachelor of Science in Physiotherapy from the University of Plymouth, England in 2008. She has been working in the field of private practice since completing her qualification exams in Canada.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/28',
        onHomePage:       true,
        type:             'practitioner',
    },
    'lauren-miller': {
        fullName:         'Lauren Miller',
        firstName:        'Lauren',
        slug:             'lauren-miller',
        mainDiscipline:   'Registered Psychotherapist (Qualifying)',
        extraDisciplines: '',
        letters:          '',
        miniBio:          'I bring an authentic, collaborative and engaged approach to counselling. I strive to foster a safe space where clients can tell their stories and gain insight into how that story has impacted you.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/31',
        onHomePage:       true,
        type:             'practitioner',
    },
    'naomi-ha': {
        fullName:         'Dr. Naomi Ha',
        firstName:        'Naomi',
        slug:             'naomi-ha',
        mainDiscipline:   'Naturopathic Doctor',
        extraDisciplines: '',
        letters:          '',
        miniBio:          'Dr. Naomi Ha is a licensed Naturopathic Doctor, in good standing with the College of Naturopaths of Ontario. She discovered Naturopathic Medicine during her undergraduate program at the University of Toronto, where she pursued studies in Health and Disease.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/16',
        onHomePage:       true,
        type:             'practitioner',
    },
    'neesa-kenemy': {
        fullName:         'Neesa Kenemy',
        firstName:        'Neesa',
        slug:             'neesa-kenemy',
        mainDiscipline:   'Pilates Instructor',
        extraDisciplines: '',
        letters:          '',
        miniBio:          'Neesa Kenemy has been teaching Pilates and Therapeutic Pilates for nineteen years. Neesa is certified through Laura Helsel at Pilates Process Inc. where she is also an instructor trainer.',
        bookingLink:      'https://pursuithealth.janeapp.com/#/staff_member/29',
        onHomePage:       false,
        type:             'instructor',
    },
    'robin-hurlow': {
        fullName:         'Robin Hurlow',
        firstName:        'Robin',
        slug:             'robin-hurlow',
        mainDiscipline:   'Yoga Instructor',
        extraDisciplines: '',
        letters:          'BSc Psychology',
        miniBio:          '',
        bookingLink:      'https://clients.mindbodyonline.com/classic/ws?studioid=780573&stype=-7&sView=week&sLoc=0&sTrn=3',
        onHomePage:       false,
        type:             'instructor',
    },
};

export default staff;
